const Theme = {
  global: {
    font: {
      family: "Gloock",
    },
    colors: {
      background: "#ffffff",
      brand: "#3d405b",
      "accent-1": "#81b29a",
      "neutral-1": "#f2cc8f",
      "neutral-2": "#a8dadc",
      "neutral-3": "#732C2C",
      "neutral-4": "#420c14",
      text: {
        light: "#005f73",
        dark: "#ffffff",
      },
    },
  },
  text: {
    font: {
      family: "Noto Sans",
    },
  },
  paragraph: {
    font: {
      family: "Noto Sans",
    },
  },
};

export default Theme;
